import { useQuery } from '@tanstack/react-query';
import { fetchThreadCapabilities } from '../api/notifications';

/**
 * What conversations can do here — a deployment fact, so fetched once and kept.
 *
 * `replyByEmail` is false until the answer arrives and when the request
 * fails: an option offering to collect replies must never appear on a
 * deployment where nothing collects them.
 */
export function useThreadCapabilities() {
  const query = useQuery({
    queryKey: ['thread-capabilities'],
    queryFn: fetchThreadCapabilities,
    staleTime: Infinity,
    retry: false,
  });
  return { replyByEmail: query.data?.replyByEmail === true, isLoading: query.isLoading };
}
